<template>
	<VButton
		:href="href"
		plain
		:aria-label="`Page `"
		:aria-current="current ? 'page' : undefined"
		:class="clsx(
			className,
			'min-w-[2.25rem] before:absolute before:-inset-px before:rounded-lg',
			current && 'before:bg-zinc-950/5 dark:before:bg-white/10')">
		<span className="-mx-0.5">
			<slot />
		</span>
	</VButton>
</template>

<script lang="ts">
	export default { name: 'VPaginationPage' } // name the component
</script>

<script setup lang="ts">
	import VButton from '@/components/Buttons/VButton.vue'

	import { 
		clsx
	} from 'clsx'

	const props = defineProps({
		ariaLabel: {
			type: String,
			default: 'Page navigation'
		},
		className: {
			type: String,
			default: ''
		},
		current: {
			type: Boolean,
			default: false
		},
		href: {
			type: String,
			default: null
		}
	})
</script>